import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { RECOMMENDATIONS_API } from '../../constants/central-api';

export default async function get_recommendation_impact_api_call(
  rec_id: string,
  tracker_access_token: string
) {
  const requestInfo: RequestInfo = {
    url: `${RECOMMENDATIONS_API}/impact?rec_id=${rec_id}`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${tracker_access_token}`,
    },
  };

  const actionType = 'GET_RECOMMENDATION_IMPACT';
  const customMsg = 'Recommendation impact data fetched successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;
  if (!response?.success) {
    return false;
  }
  if (res?.actionType === actionType && response?.success === true) {
    if (response?.data === null) {
      return null;
    } else {
      return response?.data;
    }
  }
}
